import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
var Image = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/agent-female-circle_86c456cc.svg";
import * as styles from './mobile-cta.style';

/* eslint-disable jsx-a11y/control-has-associated-label */
import { jsx as ___EmotionJSX } from "@emotion/core";
var MobileCTA = _ref => {
  var divisionName = _ref.divisionName,
    searchUri = _ref.searchUri;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  return ___EmotionJSX("a", {
    css: styles.container,
    href: getAbsoluteUrl(searchUri),
    onClick: () => {
      sendEvent('find-an-agent');
    }
  }, ___EmotionJSX("img", {
    css: styles.image,
    src: Image,
    alt: ""
  }), ___EmotionJSX("span", {
    css: styles.content
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, "Selling in ", divisionName, "?"), ___EmotionJSX("div", {
    css: styles.text
  }, "Compare these top-performing sales agents in your area")), ___EmotionJSX(ChevronRightIcon, {
    css: styles.chevron
  }));
};
MobileCTA.propTypes = {
  divisionName: PropTypes.string.isRequired,
  searchUri: PropTypes.string.isRequired
};
export default MobileCTA;